export const DISCARD_SENTRY_ERRORS = [
  // this error can be safely ignored since it doesn’t break the site
  // https://stackoverflow.com/questions/49384120/resizeobserver-loop-limit-exceeded
  // https://github.com/WICG/resize-observer/issues/38
  'ResizeObserver loop limit exceeded',

  // this error happens only on specific mobile devices (e.g. Vivo) which use
  // webview that is based on Chrome 87.
  // https://stackoverflow.com/questions/71228490/referenceerror-privatespecialrepair-is-not-defined
  'privateSpecialRepair is not defined',
];
